<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/modify-task-icon.svg" alt="Modificar tarea" />
      </div>
      <div>
        <h4 class="text-semibold">Modificar tarea</h4>
        <h6 class="color-gray" style="font-weight: 400">
          Edita los detalles de la tarea seleccionada.
        </h6>
      </div>
      <div>
        <img
          (click)="closeMdl()"
          class="close-button"
          src="assets/svg/close-icon.svg"
          alt=""
        />
      </div>
    </div>

    <div class="mdl-body">
      <div class="step-content">
        <div
          class="d-grid prospect-form"
          style="grid-template-columns: 1fr; column-gap: 32px"
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Titulo:</label
              >
              <input
                class="crm-input"
                type="text"
                placeholder="Ingresa el asunto de la actividad"
                [(ngModel)]="taskData.titulo"
                required
              />
            </div>
            <div class="mt-3">
              <label class="login-label">Comentario / Notas:</label>
              <textarea
                class="crm-input"
                placeholder="Agrega notas o comentarios para la nueva tarea (opcional)"
                rows="3"
                [(ngModel)]="taskData.comentarios"
                style="height: 98px; resize: none"
              ></textarea>
            </div>
          </div>
        </div>

        <div
          class="d-grid prospect-form"
          style="
            grid-template-columns: 1fr 1fr;
            column-gap: 32px;
            align-items: start;
          "
        >
          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Tipo de tarea:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.tipo">
                <option value="">Selecciona el tipo de tarea</option>
                <option *ngFor="let tipo of tiposTarea" [value]="tipo.valor">
                  {{ tipo.nombre }}
                </option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Estado:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.estado">
                <option value="">Selecciona el estado de la tarea</option>
                <option
                  *ngFor="let estado of estadosTarea"
                  [value]="estado.valor"
                >
                  {{ estado.nombre }}
                </option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Asignar a:</label
              >
              <div class="crm-ng-select">
                <ng-select
                  [items]="ejecutivos"
                  bindLabel="nombre"
                  bindValue="valor"
                  placeholder="Buscar usuario..."
                  [(ngModel)]="taskData.ejecutivo_id"
                  [loading]="isLoading"
                  appendTo="body"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <div class="selected-option" *ngIf="item">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <span>{{ item.nombre }}</span>
                    </div>
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="dropdown-option">
                      <img
                        src="assets/svg/user-icon.svg"
                        alt="icono"
                        class="dropdown-icon"
                      />
                      <div>
                        <div>{{ item.nombre }}</div>
                      </div>
                    </div>
                  </ng-template>

                  <ng-template ng-notfound-tmp>
                    <div class="ng-option disabled">
                      No se encontraron usuarios
                    </div>
                  </ng-template>

                  <ng-template ng-loadingtext-tmp>
                    <div class="ng-option disabled">Cargando usuarios...</div>
                  </ng-template>
                </ng-select>
              </div>
              <small
                class="text-muted"
                *ngIf="!taskData.ejecutivo_id && ejecutivos.length > 0"
              >
                Selecciona un usuario para asignar la tarea
              </small>
              <small
                class="text-danger"
                *ngIf="ejecutivos.length === 0 && !isLoading"
              >
                No se pudieron cargar los usuarios
              </small>
            </div>

            <div class="mt-3">
              <h5 class="text-semibold">Fecha de vencimiento</h5>
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Fecha:</label
              >
              <input
                class="crm-input"
                type="date"
                [(ngModel)]="taskData.fecha_vencimiento"
                [value]="getTodayDate()"
              />
            </div>
          </div>

          <div>
            <div class="mt-3">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Prioridad:</label
              >
              <select class="crm-input" [(ngModel)]="taskData.prioridad">
                <option value="">Selecciona la prioridad</option>
                <option
                  *ngFor="let prioridad of prioridades"
                  [value]="prioridad.valor"
                >
                  {{ prioridad.nombre }}
                </option>
              </select>
            </div>

            <div class="mt-3">
              <label class="login-label">Asociada a:</label>
              <div class="relacionado-container">
                <div class="tipo-selector">
                  <select
                    class="crm-input"
                    [(ngModel)]="tipoRelacionado"
                    (change)="onTipoRelacionadoChange()"
                  >
                    <option value="">Selecciona tipo</option>
                    <option value="CNT">Contacto</option>
                    <option value="ACC">Cuenta</option>
                    <option value="OPP">Oportunidad</option>
                    <option value="OTRO">Sin relación</option>
                  </select>
                </div>

                <div
                  class="elemento-selector"
                  *ngIf="tipoRelacionado && tipoRelacionado !== 'OTRO'"
                >
                  <div class="crm-ng-select">
                    <ng-select
                      [items]="elementosFiltrados"
                      bindLabel="nombre"
                      bindValue="valor"
                      [placeholder]="getPlaceholderPorTipo()"
                      [(ngModel)]="taskData.asociado_id"
                      [clearable]="true"
                      appendTo="body"
                      (clear)="limpiarSeleccionRelacionado()"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <div class="selected-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text"
                            >{{ item ? item.nombre : getPlaceholderPorTipo()
                            }}</span
                          >
                        </div>
                      </ng-template>

                      <ng-template
                        ng-option-tmp
                        let-item="item"
                        let-index="index"
                      >
                        <div class="dropdown-option">
                          <img
                            [src]="getIconForTipoRelacionado(tipoRelacionado)"
                            alt="icono"
                            class="dropdown-icon"
                          />
                          <span class="option-text">{{ item.nombre }}</span>
                        </div>
                      </ng-template>

                      <ng-template ng-notfound-tmp>
                        <div class="ng-option disabled">
                          No se encontraron {{ getTipoDisplay() }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3" style="margin-top: 65px">
              <label class="login-label"
                ><p class="color-org d-inline">*</p>
                Hora:</label
              >
              <input
                class="crm-input"
                type="time"
                [(ngModel)]="taskData.hora_vencimiento"
                value="10:00"
              />
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h5 class="text-semibold">Configuraciones adicionales</h5>
          <div
            class="d-grid prospect-form"
            style="
              grid-template-columns: 1fr 1fr;
              column-gap: 32px;
              align-items: start;
            "
          >
            <div>
              <div class="mt-3 d-flex align-items-center gap-5">
                <label class="login-label">Repetir esta tarea:</label>
                <input
                  type="checkbox"
                  id="repeatTask"
                  [(ngModel)]="showRepeatOptions"
                  style="
                    margin-left: 15px;
                    transform: translateY(-2px);
                    color: #ea5a10;
                  "
                />
              </div>

              <div *ngIf="showRepeatOptions" class="mt-3">
                <div class="mt-3">
                  <label class="login-label">Frecuencia:</label>
                  <select class="crm-input" [(ngModel)]="dummyFrecuencia">
                    <option value="">Selecciona la frecuencia</option>
                    <option value="diaria">Diaria</option>
                    <option value="semanal">Semanal</option>
                    <option value="mensual">Mensual</option>
                    <option value="anual">Anual</option>
                    <option value="personalizadoTR">
                      Personaliza fecha y hora
                    </option>
                  </select>
                </div>

                <div class="d-flex gap-3 mt-3">
                  <div style="flex: 1; margin-right: 12px">
                    <label class="login-label">Fecha inicio:</label>
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="dummyFechaInicio"
                      [value]="getTodayDate()"
                    />
                  </div>
                  <div style="flex: 1">
                    <label class="login-label">Fecha fin:</label>
                    <input
                      class="crm-input"
                      type="date"
                      [(ngModel)]="dummyFechaFin"
                      [value]="getTodayDate()"
                    />
                  </div>
                </div>

                <div class="d-flex gap-3 mt-3">
                  <div style="flex: 1; margin-right: 12px">
                    <label class="login-label">Hora inicio:</label>
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="dummyHoraInicio"
                      value="10:00"
                    />
                  </div>
                  <div style="flex: 1">
                    <label class="login-label">Hora fin:</label>
                    <input
                      class="crm-input"
                      type="time"
                      [(ngModel)]="dummyHoraFin"
                      value="10:00"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="mt-3 d-flex align-items-center gap-5">
                <label class="login-label">Recordatorio establecido:</label>
                <input
                  type="checkbox"
                  id="reminderCheckbox"
                  [(ngModel)]="showReminderOptions"
                  style="margin-left: 15px; transform: translateY(-2px)"
                />
              </div>

              <div *ngIf="showReminderOptions" class="mt-3">
                <div class="mt-3">
                  <label class="login-label">Tiempo del recordatorio:</label>
                  <select
                    class="crm-input"
                    [(ngModel)]="dummyTiempoRecordatorio"
                  >
                    <option value="">
                      Selecciona el tiempo del recordatorio
                    </option>
                    <option value="5min">5 minutos antes</option>
                    <option value="15min">15 minutos antes</option>
                    <option value="30min">30 minutos antes</option>
                    <option value="1h">1 hora antes</option>
                    <option value="1d">1 día antes</option>
                    <option value="2d">2 día antes</option>
                    <option value="personalizadoFR">
                      Personalizar fecha y hora
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="mt-5 mb-5" />

        <div class="d-flex flex-row justify-center gap-20 mt-2">
          <button class="btn btn-primary-outline" (click)="closeMdl()">
            Cancelar
          </button>

          <button
            class="btn btn-primary"
            (click)="modificarTarea()"
            [disabled]="!taskData.titulo || !taskData.estado || !taskData.tipo || !taskData.ejecutivo_id"
          >
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
